import {apiGet} from './client';

function getAccountId() {
    const STORAGE_KEY = 'celebs_account_id';
    let accountId = localStorage.getItem(STORAGE_KEY);
    if (!accountId) {
        accountId = 'user_' + (crypto.randomUUID?.() || Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2));
        localStorage.setItem(STORAGE_KEY, accountId);
    }
    return accountId;
}

export const ACCOUNT_ID = getAccountId();

export function getAccountStatus(accountId = ACCOUNT_ID) {
    return apiGet(`/celebs/account-status?account_id=${accountId}`);
}
